import * as ApiManager from '../_manager';

export const adminDashboard = {
  deployStage: (payload = null) => {
    return ApiManager.callApi ('/admin/dashboard/deployStage', payload);
  },
  getSummary: (payload = null) => {
    return ApiManager.callApi ('/admin/dashboard/index', payload);
  },
};
